import React from "react";
import c from "./common.module.scss";
import s from "./MachinelSupply.module.scss";

import SimilarSearch from "../../components/SimilarSearch";
import TabsWithMenu from "../../components/TabsWithMenu";
import TabsListView from "../../components/TabsListView";
import FixedButton from "../../components/FixedButton";

import { fetchTabCategory, fetchMachinelSupplyList } from "../../server-api/tabs";
import { parseServerDateAsYYYYMMDD, parseServerDateByTimestamp } from "../../utils/date";
import native from "../../utils/native";
import Searcth from "../Search";

// 1:普通交流,2:机械需求 3:机械供给,4:招聘,5:求职
export default function Main() {
  const [tabs, setTabs] = React.useState([]);
  const [current, setCurrent] = React.useState(0);
  const [loadingCategory, setLoadingCategory] = React.useState(true)

  React.useEffect(() => {
    document.title = "机械供给";

    fetchTabCategory(3)
    .then(res => {
      if (res.data.code === 1000) {
        const origin = res.data.data.list;
        setTabs((Array.isArray(origin) ? origin : []).map((e, index) => ({
          key: e.id,
          title: e.name,
          index: index
        })));
        setLoadingCategory(false)
      }
    });
  }, []);

  const handleGoTo = () => {
    native.openWebview("/pubsupply", {});
  };

  const handleGotoDetail = (id) => {
    native.openWebview("/supplydetail", {id});
  };

  const renderListRow = (record, key) => {
    let thumbnail = ''
    if (record.uploadFiles.length > 0) {
      thumbnail = record.uploadFiles[0].thumbnail
    }
    return <div key={key} className={s.listItem}>
      <div className={s.itemContent} onClick={() => {
        handleGotoDetail(record.id);
      }}>
        <img src={thumbnail} alt=""/>
        <div className={s.introduce}>
          <div className={s.title}>{record.title}</div>
          <div className={s.tags}>
            <span>品牌：{record.brandName}</span>
            <span>型号：{record.model}</span>
            <span>出厂日期：{parseServerDateByTimestamp(record.productionTime)}</span>
          </div>
          <div className={s.priceDate}>
            <div className={s.salary}>价格: {record.expectedSalary ? record.expectedSalary : '面议'}</div>
            <span className={s.date}>{parseServerDateAsYYYYMMDD(record.createAt)}</span>
          </div>
        </div>
      </div>
    </div>;
  };

  const [searchKey, setSearchKey] = React.useState("");
  const [showSearch, setShowSearch] = React.useState("none");

  const handleSearchOn = () => {
    setShowSearch("block");
  };

  const handleSearchOff = () => {
    setShowSearch("none");
  };

  const handleReceiveSearchKey = (x) => {
    setSearchKey(x);
  };

  if (loadingCategory) {
    return null
  }

  return <div className={c.page}>
    <div className={c.pageTop}>
      <SimilarSearch
        click={handleSearchOn}
        placeholder={"请根据您的需求输入关键词"}
        value={searchKey}
      />
    </div>
    <div className={c.pageTabs}>
      <TabsWithMenu
        tabs={tabs}
        active={current}
        setTab={setCurrent}
      />
    </div>
    <div className={c.pageContent}>
      <TabsListView
        fetchFunc={fetchMachinelSupplyList}
        renderRow={renderListRow}
        subTabKey={current}
        searchKey={searchKey}
        categoryID={tabs[current].key}
      />
    </div>
    <FixedButton text={"发布供给"} click={handleGoTo}/>
    <Searcth
      show={showSearch}
      onBack={handleSearchOff}
      receiveSearchKey={handleReceiveSearchKey}
    />
  </div>;
}
